module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d15dq"))).then(() => parcelRequire('6MybE'));